import type { SimpleAggregation } from '@core/Entities/Search/Aggregations/Aggregations.entity';

const getOptionsWithAggs = (
  filterOptions: Record<string, any>,
  aggregations: SimpleAggregation,
) => {
  return Object.keys(aggregations)
    .filter(aggKey => aggregations[aggKey] > 0 && !!filterOptions[aggKey.toString()])
    .map(aggKey => ({
      ...filterOptions[aggKey],
      count: aggregations[aggKey],
    }));
};

export { getOptionsWithAggs };
